import { useEffect, useState } from "react";
import styled from "styled-components";
import axios from "axios";
// import { useHistory } from "react-router-dom";
import MyCourseBasicInfo from "./MyCourseBasicInfo";

function MyCourses() {
  // const history = useHistory();
  const [user] = useState(JSON.parse(localStorage.getItem("user")));
  const [myCourses, setMyCourses] = useState(null);


  useEffect(() => {
    if (user?.email) {
      axios.post("/returnMyCourses", { userEmail: user.email }).then((data) => {
          const courses = data.data;
          // setMyCourses(courses)
          const currentDate = new Date()
          const validSet = new Set(
            courses
              .filter((item) => item.expiresOn && new Date(item.expiresOn) > currentDate)
              .map((item) => item.courseId)
          );
          const filtered = courses.filter((item) => {
            const isExpired = item.expiresOn && new Date(item.expiresOn) <= currentDate;
            return !(isExpired && validSet.has(item.courseId));
          })
          setMyCourses(filtered)
      });
    }
  }, [user?.email]);

  return (
    <Container>
      <CoursesContainer>
        {myCourses && (
          myCourses.map((item, key) => (
            <MyCourseBasicInfo
              key={key}
              courseID={item.courseId}
              progress={item.progressing}
              expiresOn={item.expiresOn}
            />
          ))
        )}
      </CoursesContainer>
    </Container>
  );
}

export default MyCourses;

const Container = styled.div`
  padding: 90px 20px 20px 20px;
  text-align: center;
`;

const CoursesContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(14rem, 1fr));
  grid-gap: 2rem;
`;
